import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { updateEmailAction, handleError, handleDataDomeResponse } from './common';
import { initVerificationAction } from './verification';

/*
	Actions
*/
function initEmailAction(data) {
	return {
		type: 'INIT_EMAIL',
		data: data
	}
}

function saveEmailAction(data) {
	return {
		type: 'SAVE_EMAIL',
		data: data
	}
}

/*
	Async functions
*/
export function initEmail() {
	return dispatch => {
		fetch('/api/account/email/init', {credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleInitEmail(dispatch, data))
	}
}

export function saveEmail(email, encryptedPassword, locale) {
	return (dispatch) => {
		(function resend() {
			return fetch('/api/account/email/save', {
				credentials: 'same-origin',
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					email: email,
					password: encryptedPassword,
					locale: locale,
				}),
			}).then(handleDataDomeResponse(resend));
		})().then((data) => handleSaveEmail(dispatch, data));
	};
}

/*
 Helper functions
 */
function handleInitEmail(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	switch (data.next_action.action_type) {
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/email/2-step-verification');
			break;
		case ACTION_TYPE.SAVE_EMAIL:
			dispatch(initEmailAction(data));
			browserHistory.push('/security/email/save');
			break;
		default:
			break;
	}
}

function handleSaveEmail(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.VERIFY_EMAIL) {
		dispatch(updateEmailAction(data.next_action.verified_info.email));
		browserHistory.push('/security/verify_email/verify');
	}
	dispatch(saveEmailAction(data));
}


// WEBPACK FOOTER //
// ./app/actions/email.js